module.exports = __webpack_public_path__ + "static/media/bg-title.f74a691c.jpg";